module.exports = __webpack_public_path__ + "img/12.3002d899.jpg";